import { useEffect, useRef } from 'react';

const BEEHIIV_FORM_ID = '72c5bcf1-7256-4958-8495-841960c99a9d';
const BEEHIIV_LOADER_URL = 'https://subscribe-forms.beehiiv.com/v3/loader.js';

export function BeehiivSubscribeForm() {
  const mountRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const mount = mountRef.current;
    if (!mount) return;

    const script = document.createElement('script');
    script.setAttribute('async', '');
    script.src = BEEHIIV_LOADER_URL;
    script.dataset.beehiivForm = BEEHIIV_FORM_ID;
    mount.appendChild(script);

    return () => mount.replaceChildren();
  }, []);

  return <div className="beehiiv-subscribe" ref={mountRef} />;
}
